const TextInputFormik = ({
  label,
  type = "text",
  field,
  formik,
  readOnly = false,
  required = true,
  placeholder = null,
}) => {
  return (
    <div className="input-block mb-3">
      <label className="col-form-label">
        {label} {required && <span className="text-danger">*</span>}
      </label>

      <input
        className="form-control"
        type={type}
        placeholder={placeholder}
        name={field}
        value={formik?.values?.[field] || ""}
        onChange={formik?.handleChange}
        onBlur={formik?.handleBlur}
        readOnly={readOnly}
      />

      {formik?.errors?.[field] && formik?.touched?.[field] && (
        <span className="text-danger">{formik.errors[field]}</span>
      )}
    </div>
  );
};

export default TextInputFormik;
